// Подстановка и склонения без словаря: их берёт и лёгкая страница клиента (`@glory/i18n/portal`), которой
// не нужен весь словарь платформы.

export interface PluralForms {
  readonly one: string;
  readonly few: string;
  readonly many: string;
  readonly other: string;
}

const numberFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
const pluralRules = new Intl.PluralRules('ru');

/** Подстановка {name} → значение; числа форматируются по-русски. */
export function interpolate(
  template: string,
  params: Readonly<Record<string, string | number>> = {},
): string {
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    if (value === undefined) return match;
    return typeof value === 'number' ? numberFormat.format(value) : value;
  });
}

/** Склонение по числу с подстановкой {count}. */
export function plural(forms: PluralForms, count: number): string {
  const category = pluralRules.select(count);
  const template =
    category === 'one' || category === 'few' || category === 'many' ? forms[category] : forms.other;
  return interpolate(template, { count });
}
